import { Route, Routes } from 'react-router-dom'
import { PATH } from '~/AppRoutes'
import { useCurrentUser } from '~/common'
import { BillingunitDetailsPage, BillingunitEditPage, BillingunitsPage } from '~/modules/billingunits/view'
import { AuthWrapped } from '~/modules/navigation/components'

export const BillingunitRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('CCC')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={BillingunitsPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.EDIT}/:id`}
        element={<AuthWrapped component={BillingunitEditPage} canAccess={canAccess} />}
      />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={BillingunitDetailsPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const billingUnitLinks = {
  billingUnitsLink: () => PATH.OVERVIEW,
  billingUnitsDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  billingUnitsEditLink: (id: string) => `/${PATH.EDIT}/${id}`,
}
